import "./ProfilePage.css";
import React, { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { fetchLogindata, setStoreIpAddress } from "./../../login/redux/actions";
import { connect, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import profileDefault from "../../../assets/profile_default.png";
import storage from "redux-persist/lib/storage";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import { maintainCartdata } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { logOutAPI } from "../../login/util/logout";
import { currentLocationInfo } from "../../home/redux/actions";
import { fetchChatuserlist } from "../../header/redux/actions";
import { storeChathistory } from "../../header/redux/actions";
import { storeConnection } from "../../header/redux/actions";
import { formatPhoneNumber } from "../../comman/components/TimeSence";
import { formatPhoneNumberturkish } from "../../comman/components/TimeSence";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { EYE, EYE_OFF } from "../../comman/components/CommonimagePath";
import UploadfilesPage from "../../tusimageupload/components/UploadfilesPage";
import {
  PROFILE,
  CHANGE_PASSWORD,
  DELETE_ACCOUNT,
} from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import { postRequestcall } from "../../comman/util/postRequest";
import { FormLabel,FormControl } from "../../comman/formgroup/FormgroupPage";
import InputgroupPage from "../../comman/inputgroup/InputgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { setStoreMessageReceived } from "../../chat/redux/actions";

const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function ProfilePage(props) {
  const { t } = useTranslation();
  const { logindata, access_token } = props;
  const [deleteModal, setDeleteModal] = useState(false);
  const { pathname } = useLocation();
  console.log("location", logindata)
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.deletepop.deleteaccount"),
    sub_title: t("pages.deletepop.deleteaccount_subtitle"),
    name: "",
    id: "",
    type: "",
  });
  const eye = {
    current_password: "",
    confirm_password: "",
    password: "",
  };
  const [profileInput, setProfileInput] = useState({
    first_name: "",
    email: "",
    mobile: "",
    image: "",
    image_url: "",
    current_password: "",
    confirm_password: "",
    password: "",
    country_code: "",
  });
  const [eyes, setEyes] = useState(eye);
  const [errors, setErrors] = useState({
    first_name: "",
    email: "",
    mobile: "",
    current_password: "",
    confirm_password: "",
    password: "",
  });
  const dispatch = useDispatch();
  const passRegex =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\w\W]){1,})(?!.*\s).{8,}$/;
  const navigate = useNavigate();
  useEffect(() => {
    callgetProfileDetail();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.deletepop.deleteaccount"),
      sub_title: t("pages.deletepop.deleteaccount_subtitle"),
      name: "",
      id: "",
      type: "",
    });
    // eslint-disable-next-line
  }, [props?.language]);

  const callgetProfileDetail = async () => {
    const responseProfile = await getRequestcall(PROFILE, access_token);
    if (responseProfile?.status === 200) {
      let getprofile = await responseProfile.json();
      setProfileInput({
        email: getprofile?.data?.email,
        mobile: getprofile?.data?.mobile,
        country_code: getprofile?.data?.country_code,
        first_name: getprofile?.data?.first_name,
        image: getprofile?.data?.image,
        image_url: getprofile?.data?.image_url,
        current_password: "",
        confirm_password: "",
        password: "",
      });
    }
  };
  const validation = () => {
    let value = true;
    if (profileInput.first_name === "") {
      value = false;
      errors.first_name = "pages.settings.username_warn";
    }
    setErrors({
      ...errors,
      first_name: errors.first_name,
    });

    return value;
  };
  const InputChange = (e) => {
    setProfileInput({
      ...profileInput,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };
  const callUpdateProfile = async (e) => {
    e.preventDefault();
    if (validation()) {
      const payload = {
        email: profileInput?.email,
        first_name: profileInput?.first_name,
        mobile: profileInput?.mobile,
        image: profileInput?.image,
      };
      const responceUpdateProfile = await postRequestcall(
        PROFILE,
        access_token,
        payload
      );
      if (responceUpdateProfile?.status === 200) {
        const resultResponce = await responceUpdateProfile.json();
        props.fetchLogindata({
          ...logindata,
          email: resultResponce?.data?.email,
          first_name: resultResponce?.data?.first_name,
          mobile: resultResponce?.data?.mobile,
          image: resultResponce?.data?.image,
          image_url: resultResponce?.data?.image_url,
        });
        toast.success(t("pages.profile.toast_profile"));
      }
    }
  };

  const validationForpass = () => {
    let value = true;
    if (profileInput.current_password === "") {
      value = false;
      errors.current_password = "pages.profile.current_password_place";
    }
    if (profileInput.password !== profileInput.confirm_password) {
      value = false;
      errors.confirm_password = "pages.profile.confirm_password_valid";
    }
    if (!profileInput.password.match(passRegex)) {
      value = false;
      errors.password = "pages.profile.new_password_valid";
    }
    if (profileInput.password === "") {
      value = false;
      errors.password = "pages.profile.new_password_warn";
    }
    if (profileInput.confirm_password === "") {
      value = false;
      errors.confirm_password = "pages.profile.confirm_password_warn";
    }
    setErrors({
      ...errors,
      current_password: errors.current_password,
      confirm_password: errors.confirm_password,
      password: errors.password,
    });
    return value;
  };
  const callUpdatePassword = async (e) => {
    e.preventDefault();
    if (validationForpass()) {
      const payload = {
        current_password: profileInput.current_password,
        password: profileInput.password,
        confirm_password: profileInput.confirm_password,
      };
      const responcePassword = await postRequestcall(
        CHANGE_PASSWORD,
        access_token,
        payload
      );
      if (responcePassword?.status === 200) {
        await responcePassword.json();
        toast.success(t("pages.profile.toast_password"));
      } else if (responcePassword.status === 400) {
        const result = await responcePassword.json();
        toast.error(result?.errors);
      }
    }
  };
  const callLogout = async () => {
    const responceLogout = await logOutAPI(props?.access_token);
    if (responceLogout !== null) {
      if (responceLogout?.status === 200) {
        clearReduxdata();
      } else if (responceLogout?.status === 302) {
        clearReduxdata();
      } else {
        clearReduxdata();
      }
    } else {
      clearReduxdata();
    }
  };

  const clearReduxdata = () => {
    dispatch(setStoreIpAddress(""));
    props.fetchLogindata({});
    props.fetchStoredetail([]);
    props.maintainCartdata([], {});
   // props.currentLocationInfo({});
    props.fetchChatuserlist([]);
    props.storeConnection({});
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    storage.removeItem("persist:persist-store");
    navigate("/");
  };

  const callDeleteAccountAPI = async () => {
    let responce = await getRequestcall(DELETE_ACCOUNT + `?lang=${props.language.toLowerCase()}`, props?.access_token);
    if (responce?.status === 200) {
      callLogout();
    }else{
      if (responce?.status === 400) {
        const result = await responce?.json()
        toast.info(result?.errors);
      }
    }
  };

  const DeleteAccount = () => {
    let title = t("pages.deletepop.deleteaccount");
    let sub_title = t("pages.deletepop.deleteaccount_subtitle");
    if(logindata?.type === "vendor" && logindata?.vendor_type !== "driver"){
      title = t("pages.Do you really want to delete this store?")
      sub_title = t("pages.If you delete this store then the store vendor becomes a user!")
    }
    if(logindata?.type === "vendor" && logindata?.vendor_type === "driver"){
      title = t("pages.Do you really want to delete this driver?")
      sub_title = t("pages.If you delete this driver then the driver becomes a user!")
    }
    setDeleteinfo({
      ...deleteInfo,
      title:title,
      sub_title:sub_title,
      name: "",
      id: "",
    });
    setDeleteModal(true);
  };

  const storeFiles = (getImage, type) => {
    setProfileInput({
      ...profileInput,
      image: getImage.fileName,
      image_url: getImage.preview_url,
    });
  };

  return (
    <div className="main-content setting-centent">
      <div className="card p-3">
        <div className="card-body p-0">
          <h5 className="header-title mb-3">{t("pages.profile.info")}</h5>
          <Form>
            <Row>
              <div className="col-12">
                <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 upload-profiles">
                <Form.Group>
                   <FormLabel label={t("pages.profile.image")}></FormLabel>
                  </Form.Group>
                  <div className="select-image-preview">
                    <UploadfilesPage storeFiles={storeFiles} />
                  </div>
                  <div className="select-image-preview">
                    <LazyLoadImage
                      onError={(event) => {
                        event.target.src = profileDefault;
                      }}
                      src={
                        profileInput.image === null
                          ? profileDefault
                          : profileInput.image_url
                      }
                      alt={""}
                    />
                  </div>
                 </div>
               </div>
              <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                <FormLabel label={t("pages.profile.username")} />
                <FormControl placeholder={t("pages.profile.username_place")} 
                value={profileInput.first_name}
                name={"first_name"} 
                type={"text"} 
                onChange={InputChange} 
                error={t(errors.first_name)} />
              </div>
              <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
              <FormLabel label={t("pages.profile.email_address")} />
                  <FormControl
                    onChange={InputChange}
                    value={profileInput.email}
                    name={"email"}
                    placeholder={t("pages.profile.email_address_place")}
                    disabled={true}
                  />
              </div>
              <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
               <FormLabel label={t("pages.profile.mobile")} />
                  <FormControl
                    type={"text"}
                    onChange={InputChange}
                    value={
                      profileInput.country_code === "+91"
                        ? profileInput.country_code +
                          " " +
                          formatPhoneNumber(profileInput.mobile)
                        : profileInput.country_code +
                          " " +
                          formatPhoneNumberturkish(profileInput.mobile)
                    }
                    name={"mobile"}
                    placeholder={t("pages.profile.mobile_place")}
                    disabled={true}
                  />
               </div>
              <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-right">
                <ButtonPage
                  type="submit"
                  className="button-submit mt-2 hover-btn ml-auto"
                  onClick={(e) => callUpdateProfile(e)}
                  Text={t("pages.profile.updateprofile")}
                />
              </div>
              <h5 className="header-title mb-3 mt-3">
                {t("pages.profile.changePassword")}
              </h5>
              <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                <FormLabel label={t("pages.profile.current_password")} />
                <InputgroupPage 
                 onChange={InputChange}
                 value={profileInput.current_password}
                 type={eyes.current_password ? "text" : "password"}
                 placeholder={t("pages.profile.current_password_place")}
                 name={"current_password"}
                 onClick={() =>
                  setEyes({
                    ...eyes,
                    current_password: !eyes.current_password,
                  })}
                 src={eyes.current_password ? EYE : EYE_OFF}
                />
                 <span className="text-danger">
                  {t(errors.current_password)}
                </span>
              </div>
              <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
               <FormLabel label= {t("pages.profile.new_password")} />
               <InputgroupPage 
                 onChange={InputChange}
                 value={profileInput.password}
                 type={eyes.password ? "text" : "password"}
                 placeholder={t("pages.profile.new_password_place")}
                 name={"password"}
                 onClick={() =>
                  setEyes({ ...eyes, password: !eyes.password })
                }
                src={eyes.password ? EYE : EYE_OFF}
                />
                   <span className="text-danger">
                  {t(errors.password)}
                </span>
              </div>
              <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
              <FormLabel label={t("pages.profile.confirm_password")} />
              <InputgroupPage 
                 onChange={InputChange}
                 value={profileInput.confirm_password}
                 type={eyes.confirm_password ? "text" : "password"}
                 placeholder={t("pages.profile.confirm_password_place")}
                 name={"confirm_password"}
                 onClick={() =>
                  setEyes({
                    ...eyes,
                    confirm_password: !eyes.confirm_password,
                  })
                }
                src={eyes.confirm_password ? EYE : EYE_OFF}
                />
                <span className="text-danger">
                  {t(errors.confirm_password)}
                </span>
              </div>
              <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-right">
                <ButtonPage
                  type="submit"
                  className="button-submit mt-2 hover-btn ml-auto"
                  onClick={(e) => callUpdatePassword(e)}
                  Text={t("pages.profile.updatepassword")}
                />
                  
              </div>
              
             {( pathname !== "/user/settings" || logindata.type !== "vendor" )&&(
              <React.Fragment>
                <hr className="mt-2" />
                <div className="d-flex align-center justify-content-between align-items-start">
                  <div className="d-flex flex-col">
                  <FormLabel label={t("pages.settings.delete_account")} />
                    <span className="secound-text">
                      {t("pages.settings.delete_description")}
                    </span>
                  </div>
                  <span
                    onClick={() => DeleteAccount()}
                    className={"primary-text fw-semibold hover"}
                  >
                    {t("pages.settings.delete_account")}
                  </span>
                </div>
              </React.Fragment>
             )}
            </Row>
          </Form>
        </div>
      </div>
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={callDeleteAccountAPI}
        ></DeletepopupPage>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  logindata: state?.login?.logindata,
  storeDetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  fetchLogindata,
  fetchStoredetail,
  maintainCartdata,
  currentLocationInfo,
  fetchChatuserlist,
  storeConnection,
  storeChathistory,
})(ProfilePage);
